"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.155 13.602V1.898a.5.5 0 0 0-.5-.5h-2.094a.5.5 0 0 0-.5.5v11.036h1V2.398h1.094v11.204h-2.761V5.53a.5.5 0 0 0-.5-.5H8.8a.5.5 0 0 0-.5.5v7.404h1V6.03h1.094v7.572H7.633V8.417a.5.5 0 0 0-.5-.5H5.039a.5.5 0 0 0-.5.5v4.495h1V8.917h1.094v4.685H3.871V9.98a.5.5 0 0 0-.5-.5H1.278a.5.5 0 0 0-.5.5v3.622H0v1h1.278a.5.5 0 0 0 .5-.5V10.48h1.093v3.122h-.662v1H16v-1h-.845Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.546 20.59V2.847a.563.563 0 0 0-.563-.562h-3.14a.563.563 0 0 0-.563.562v16.554h1.125V3.41h2.016v17.18h-4.517V8.294a.563.563 0 0 0-.562-.563H13.2a.562.562 0 0 0-.563.563v11.107h1.125V8.856h2.016V20.59h-4.517v-7.965a.563.563 0 0 0-.563-.562H7.56a.563.563 0 0 0-.563.562v6.743h1.125v-6.18h2.016v7.402H5.62v-5.62a.563.563 0 0 0-.562-.562H1.917a.563.563 0 0 0-.563.562v5.62H0v1.125h1.917c.31 0 .562-.252.562-.562v-5.62h2.016v5.057H3.313v1.125H24V20.59h-1.454Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.061 27.454V3.797a.75.75 0 0 0-.75-.75h-4.188a.75.75 0 0 0-.75.75v22.07h1.5V4.548h2.688v22.907h-6.022V11.059a.75.75 0 0 0-.75-.75h-4.188a.75.75 0 0 0-.75.75v14.809h1.5v-14.06h2.688v15.646h-6.023v-10.62a.75.75 0 0 0-.75-.75h-4.188a.75.75 0 0 0-.75.75v8.99h1.5v-8.24h2.688v9.87H7.494V19.96a.75.75 0 0 0-.75-.75H2.556a.75.75 0 0 0-.75.75v7.493H0v1.5h2.556a.75.75 0 0 0 .75-.75V20.71h2.688v6.743H4.418v1.5H32v-1.5h-1.939Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.905 41.368V5.695a.937.937 0 0 0-.938-.938h-6.282a.937.937 0 0 0-.937.938v33.107h1.875V6.632h4.407v34.736h-9.41V16.59a.938.938 0 0 0-.938-.937H26.4a.937.937 0 0 0-.937.937v22.213h1.875V17.526h4.407v23.842h-9.409V25.251a.937.937 0 0 0-.937-.938h-6.282a.937.937 0 0 0-.938.938v13.485h1.875V26.188h4.407v15.18h-9.409V29.94a.938.938 0 0 0-.937-.937H3.834a.937.937 0 0 0-.938.938v11.427H0v1.875h3.834c.517 0 .937-.42.937-.937V30.878h4.407v10.49h-2.55v1.875H48v-1.875h-3.095Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.873 55.158V7.593c0-.691-.56-1.25-1.25-1.25h-8.376a1.25 1.25 0 0 0-1.25 1.25v44.143h2.5V8.843h5.876v46.315H44.828v-33.04c0-.69-.56-1.25-1.25-1.25h-8.376c-.691 0-1.25.56-1.25 1.25v29.618h2.5V23.369h5.876v31.789H29.783v-21.49c0-.691-.56-1.25-1.25-1.25h-8.376a1.25 1.25 0 0 0-1.25 1.25v17.98h2.5v-16.73h5.876v20.24H14.738V39.92c0-.69-.56-1.25-1.25-1.25H5.112c-.691 0-1.25.56-1.25 1.25v15.237H0v2.5h5.112c.69 0 1.25-.56 1.25-1.25V41.17h5.876v13.987h-3.4v2.5H64v-2.5h-4.127Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconGraph = function IconGraph(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Graph' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Graph"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconGraph.sizes = [16, 24, 32, 48, 64];
IconGraph.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconGraph;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Graph.js
// module id = 1765
// module chunks = 0